<div class="claim-insurance-modal" *transloco="let t; prefix: 'accidents'">
  <div class="claim-insurance-modal__header">
    <h3 class="claim-insurance-modal__title">{{ title }}</h3>
    <button type="button" class="icon-btn" [attr.aria-label]="'common.close' | transloco" (click)="cancel()">
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M18 6L6 18M6 6l12 12"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round">
        </path>
      </svg>
    </button>
  </div>

  <div class="claim-insurance-modal__tabs">
    <button
      type="button"
      class="tab-btn"
      [class.active]="activeTab === claimInsuranceTab.Documents"
      (click)="setActiveTab(claimInsuranceTab.Documents)">
      {{ t('modals.claimInsurance.tabs.documents') }}
    </button>
    <button
      type="button"
      class="tab-btn"
      [class.active]="activeTab === claimInsuranceTab.Insurance"
      (click)="setActiveTab(claimInsuranceTab.Insurance)">
      {{ t('modals.claimInsurance.tabs.insuranceClaim') }}
    </button>
  </div>

  <!-- Both tabs stay mounted so switching keeps in-flight uploads and typed claim details -->
  <app-documents-tab
    [hidden]="activeTab !== claimInsuranceTab.Documents"
    [assetId]="assetId"
    [uploadedDocuments]="uploadedDocuments"
    (documentsChange)="onDocumentsChange($event)"
    (cancelled)="cancel()"
    (save)="onDocumentsSave($event)">
  </app-documents-tab>

  <app-insurance-claim-tab
    [hidden]="activeTab !== claimInsuranceTab.Insurance"
    [accident]="accident"
    [isSubmitting]="isSubmitting"
    [areDocumentsReady]="areDocumentsReady"
    (cancel)="cancel()"
    (save)="onInsuranceClaimSave($event)">
  </app-insurance-claim-tab>
</div>